var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossNoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.32 12.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05.28a.94.94 0 0 0-1.32 0L6.16 4.84 1.59.27a.94.94 0 0 0-1.32 0 .94.94 0 0 0 0 1.32l4.57 4.57-4.57 4.57a.94.94 0 0 0 0 1.32.94.94 0 0 0 1.32 0l4.57-4.57 4.57 4.57a.93.93 0 0 0 1.32-1.32L7.48 6.16l4.57-4.57a1 1 0 0 0 0-1.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossNoFill);
export default __webpack_public_path__ + "static/media/cross-no-fill.aa617456947bed9113cbe8502e70463a.svg";
export { ForwardRef as ReactComponent };